import {Directive, ElementRef} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[particleOffsetTop]'
})
export class OffsetTopDirective {

  constructor(private _el: ElementRef) { }
  get offsetTop(): number { return this._el.nativeElement.offsetTop; }
}
